export const countryCode = {
    UAE: '971',
}